module.exports = __webpack_public_path__ + "static/media/plot.d245751b.log";